
import { BottomLinks } from './components/bottom-links';
import { FooterDescription } from './components/footer-description';
import {
  bottomLinks,
  carsLinks,
  comingSoonLinks,
  electricLinks,
  newArrivalsLinks,
  newsLinks,
  serviceLinks,
  stockLinks,
  vansLinks,
} from './components/links';
import { LinksList } from './components/links-list';
import { SocialInfo } from './components/social-info';

const FooterNew = () => {
  return (
    <footer className="w-full bg-white border-t border-gray-300">
      <div className="xl:max-w-[1350px] lg:max-w-[984px] md:max-w-[712px] mx-auto px-[25px]">
        <div className="py-10 xl:py-20 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-[1fr_3fr] gap-10 lg:gap-0 xl:gap-20">
          <div className="flex flex-col items-center xl:items-start">
            <SocialInfo />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 justify-center  gap-16 lg:gap-3 xl:gap-24">
          <div className="flex flex-col ml-auto gap-10 ">
              <LinksList title="New Cars Offer" items={carsLinks} />
            </div>

            <div className="flex flex-col  gap-10">
              <LinksList title="New Arrivals" items={newArrivalsLinks} />
              <LinksList title="Coming Soon" items={comingSoonLinks} />
              <LinksList title="Electric" items={electricLinks} />
            </div>

            <div className="flex flex-col ml-auto gap-10 ">
              <LinksList title="New Vans Offer" items={vansLinks} />
              <LinksList title="Stock" items={stockLinks} />
              <LinksList title="News" items={newsLinks} />
            </div>

            <div className="flex flex-col gap-10 sm:pb-0 pb-3">
              <LinksList title="Services" items={serviceLinks} />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-white border-t border-gray-300">
        <div className="xl:max-w-[1388px] lg:max-w-[984px] md:max-w-[712px] mx-auto">
          <div className="sm:px-3 px-3 mt-5">
            <BottomLinks items={bottomLinks} />
            <FooterDescription />
          </div>
        </div>
      </div>
      <div className="bg-gray-200">
        <div className="max-w-[1139px] mx-auto text-center font-medium  py-5 text-slate-800 text-base">
          Copyright © Advance Motors Limited. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};


export default FooterNew